import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import '../../css/phone/phone.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { changeJanusStatus } from '../../redux/parametersSlice';
import axios from 'axios';
import SignalRService from '../../controllers/SignalRService';
import Contact from '../contacts/contact';

class Options extends Component {
    constructor() {

        super();

        this.state = { 
            showContactModal: false 
        };

        this.toggleContactModal = this.toggleContactModal.bind(this);
    }
    clickFunctionButton = data => {

        console.log(data);

        if (data.function === "URL") {

            let url = data.parameter.replace("{agent_ext}", this.props.extension)
                .replace("{agent_userId}", this.props.userId)

            window.open(url);
        }
        else if (data.function === "AJAX") {

            if (data.method === "GET") {

                let url = data.parameter.replace("{agent_ext}", this.props.extension)
                    .replace("{agent_userId}", this.props.userId);

                axios({ method: "get", url: url });
            }
            if (data.method === "POST") {

                let url = data.parameter.replace("{agent_ext}", this.props.extension)
                    .replace("{agent_userId}", this.props.userId);

                axios({
                    method: "post",
                    url: url,
                    data: data.jsonData
                });
            }
        }
        else {

            let message = {
                extension: this.props.extension,
                userId: this.props.userId,
                buttonId: data.buttonId
            };

            SignalRService.functionButton(message);
        }
    }

    toggleContactModal() {
        this.setState({ showContactModal: !this.state.showContactModal });
    }

    render() {
        return (<>
            <div ref={this.props.optWrapperRef} className='options'>
                <button className='option' onClick={this.props.toggleQuery}>
                    <Row>
                        <Col md={1}>
                            <FontAwesomeIcon icon={duotone('square-question')} />
                        </Col>
                        <Col>
                            <div className="fs-7">{this.props.t("query")}</div>
                        </Col>
                    </Row>
                </button>
                {
                    (this.props.functions.agentAutoAnswer) &&
                    <button className='option' onClick={this.props.toggleAutoAnswer}>
                        <Row>
                            <Col md={1}>
                                {
                                    (this.props.functions && !this.props.autoAnswer) &&
                                    <FontAwesomeIcon icon={duotone('square-a')} />
                                }
                                {
                                    (this.props.functions && this.props.autoAnswer) &&
                                    <FontAwesomeIcon icon={duotone('square-a-lock')} />
                                }
                            </Col>
                            <Col>
                                <div className="fs-7"> {this.props.t("autoanswer")}</div>
                            </Col>
                        </Row>
                    </button>
                }
                {
                    (this.props.functions.clasify && ["TALKING", "HELD", "DIALING", "RINGING"].indexOf(this.props.phoneStatus.ctiStatus) > -1) &&
                    <button className='option' onClick={this.toggleCategories}>
                        <Row>
                            <Col md={1}>
                                <FontAwesomeIcon icon={duotone('tag')} />
                            </Col>
                            <Col>
                                <div className="fs-7">{this.props.t("setcategory")}</div>
                            </Col>
                        </Row>
                    </button>
                }
                {
                    (this.props.functions.functionButtons && this.props.functions.functionButtons.length > 0) &&
                    this.props.functions.functionButtons.map((m) => {
                        return (
                            <button key={m.buttonId} className='option' onClick={e => { this.clickFunctionButton(m) }}>
                                <Row>
                                    <Col md={1}>
                                        <FontAwesomeIcon icon={duotone('list')} />
                                    </Col>
                                    <Col>
                                        <div className="fs-7">{m.name}</div>
                                    </Col>
                                </Row>
                            </button>)
                    })
                }

                {
                    (["TALKING", "HELD", "DIALING", "RINGING"].indexOf(this.props.phoneStatus.ctiStatus) > -1 && !this.props.partyName) &&
                    <>
                        <button className='option' onClick={this.toggleContactModal}>
                            <Row>
                                <Col md={1}>
                                    <FontAwesomeIcon icon={duotone('square-plus')}/>
                                </Col>
                                <Col>
                                    <div className="fs-7">{this.props.t("addcontact")}</div>
                                </Col>
                            </Row>
                        </button>
                    </>
                }
            </div>
            <Contact show={this.state.showContactModal} toggleModal={this.toggleContactModal} action="addcontact" contactId={null} reload={null} phone={this.props.party}></Contact>

        </>)
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        functions: state.agent.functions,
        phoneStatus: state.agent.phoneStatus,
        party: state.agent.party,
        partyName: state.agent.partyName
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(Options);